<template>
  <div class="vaccine-check-list">
    <div class="column single">
      <vaccine-check-list-item
        v-for="vaccine in singleVaccines"
        :checked-id="checkedId"
        :key="vaccine.id"
        :vaccine="vaccine"
        @check="checkVaccine"
      />
    </div>
    <div class="column mixed">
      <vaccine-check-list-item
        v-for="vaccine in mixedVaccines"
        :checked-id="checkedId"
        :key="vaccine.id"
        :vaccine="vaccine"
        @check="checkVaccine"
      />
    </div>
  </div>
</template>

<script>
import VaccineCheckListItem from '@/components/parts/atoms/VaccineCheckListItem'
import {
  catMixedVaccineIds,
  catSingleVaccineIds,
  dogMixedVaccineIds,
  dogSingleVaccineIds
} from '@/utils/vaccine_utils'
import { mapGetters } from 'vuex'

export default {
  name: 'VaccineCheckList',

  components: { VaccineCheckListItem },

  props: {
    checkedId: { type: Number, default: 0 },
    vaccineTypeId: { type: Number, default: 0 }
  },

  computed: {
    ...mapGetters({
      getMasterDatum: 'master/getDataById'
    }),
    mixedVaccines() {
      const vaccineIds =
        this.vaccineTypeId === 1
          ? dogMixedVaccineIds
          : this.vaccineTypeId === 2
          ? catMixedVaccineIds
          : []
      return this.makeVaccines(vaccineIds)
    },
    singleVaccines() {
      const vaccineIds =
        this.vaccineTypeId === 1
          ? dogSingleVaccineIds
          : this.vaccineTypeId === 2
          ? catSingleVaccineIds
          : []
      return this.makeVaccines(vaccineIds)
    }
  },

  methods: {
    checkVaccine(id) {
      this.$emit('check', id)
    },
    makeVaccines(vaccineIds) {
      return vaccineIds
        .map(id => this.getMasterDatum('vaccines', id))
        .filter(vaccine => !!vaccine)
    }
  }
}
</script>

<style lang="scss" scoped>
.vaccine-check-list {
  display: flex;
  column-gap: 20px;
  > .column {
    display: flex;
    flex-direction: column;
    row-gap: 10px;
  }
}
</style>
